// headers for the api request
const headers = {
  "Content-Type": "application/x-www-form-urlencoded",
  "X-Requested-With": "XMLHttpRequest",
};

// function to handle the form submission
export const processForm = async (formData) => {
  return fetch("/civicrm/ajax/api4/CampaignSubmission/create", {
    method: "POST",
    headers,
    body: new URLSearchParams({
      params: JSON.stringify({
        values: formData,
      }),
    }),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
    })
    .then((records) => {
      return records.values[0];
    })
    .catch((error) => {
      throw new Error(
        "Error in campaign signing! Kindly, refresh the page and try again."
      );
    });
};

// function to get campaign data and contact information
export const prefillForm = async (campaign_id, contact_id, checksum) => {
  // fetch campaign info along with contact info if contact_id is provided
  return fetch("/civicrm/ajax/api4/CampaignConfig/prefill", {
    method: "POST",
    headers,
    body: new URLSearchParams({
      params: JSON.stringify({
        where: [
          ["survey_id", "=", campaign_id],
          ["contact_id", "=", contact_id],
          ["checksum", "=", checksum],
        ],
      }),
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((records) => {
      return records.values[0];
    });
};

// form reducer for form processing
export const formReducer = (state, event) => {
  return {
    ...state,
    [event.name]: event.value,
  };
};

// get the list of petition or email to target
export const getCampaignData = async (campaign_type, term) => {
  return fetch("/civicrm/ajax/api4/Survey/get", {
    method: "POST",
    headers,
    body: new URLSearchParams({
      params: JSON.stringify({
        where: [
          ["activity_type_id:name", "=", campaign_type],
          ["title", "LIKE", "%" + term + "%"],
        ],
        checkPermissions: false,
        orderBy: { title: "ASC" },
      }),
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((records) => {
      return records;
    });
};

// function to get target contact information
export const getTargetContactInfo = async (
  country_id,
  campaign_id,
  first_name,
  last_name,
  email
) => {
  // fetch target contact info
  return fetch("/civicrm/ajax/api4/CampaignSubmission/ettinfo", {
    method: "POST",
    headers,
    body: new URLSearchParams({
      params: JSON.stringify({
        where: [
          ["country_id", "=", country_id],
          ["campaign_id", "=", campaign_id],
          ["first_name", "=", first_name],
          ["last_name", "=", last_name],
          ["email", "=", email],
        ],
      }),
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((records) => {
      return records.values[0];
    });
};

// function to handle the form submission for ETT step 2
export const processETTForm = async (formData) => {
  return fetch("/civicrm/ajax/api4/CampaignSubmission/ettsend", {
    method: "POST",
    headers,
    body: new URLSearchParams({
      params: JSON.stringify({
        values: formData,
      }),
    }),
  }).then((res) => {
    if (!res.ok) {
      console.log("Error in ett campaign signing");
    }
  });
};

// function to handle the form submission
export const processCommunicationForm = async (formData) => {
  return fetch("/civicrm/ajax/api4/CommunicationSubmission/create", {
    method: "POST",
    headers,
    body: new URLSearchParams({
      params: JSON.stringify({
        values: formData,
      }),
    }),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
    })
    .then((records) => {
      return records.values[0];
    })
    .catch((error) => {
      throw new Error(
        "Error in communication signing! Kindly, refresh the page and try again."
      );
    });
};

// function to get recaptcha settings
export const getSettings = async () => {
  // fetch settings
  return fetch("/civicrm/ajax/api4/CommunicationSubmission/prefill", {
    method: "POST",
    headers,
  })
    .then((res) => {
      return res.json();
    })
    .then((records) => {
      return records.values[0];
    });
};
